import styled, { keyframes } from "styled-components";
import { zIndex } from "../../../constants";
import { buttonResetStyles } from "../../../utils";
import { colors } from "../../../utils/colors";

export const SlideInAnimation = keyframes`
    100% {
        opacity: 1;
        transform: translateY(0%);
    }
`;

export const Outer = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: ${zIndex.pwaInstallPrompt};
    padding: 16px;

    opacity: 0;
    transform: translateY(100%);
    animation: ${SlideInAnimation} 300ms ease 1s forwards;
`;

export const Inner = styled.div`
    position: relative;
    background-color: white;
    padding: 12px;
    border-radius: 12px;
    box-shadow: 0 3px 10px hsla(0, 0%, 0%, 30%);

    display: flex;
    align-items: center;
    gap: 12px;
`;

export const Icon = styled.img`
    width: 44px;
    height: 44px;
    border-radius: 8px;
`;

export const Copy = styled.div``;

export const Title = styled.div`
    font-weight: 700;
    font-size: 14px;
`;

export const Subtitle = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
    font-size: 12px;

    svg {
        font-size: 14px;
        color: ${colors.brandMid};
    }
`;

export const CloseButton = styled.button`
    ${buttonResetStyles}
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${colors.brandDark};
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: 0;
    right: 0;
    transform: translate(40%, -40%);

    svg {
        font-size: 16px;
    }
`;
